import MyTable from 'components/UIElements/MyTable';

export default function DeviceStatus({ endPoint, exportFilename }) {
  const columns = [
    {
      title: 'Αρ. Συμβολαίου',
      key: 'policyNumber',
      dataIndex: 'policyNumber'
    },
    {
      title: 'ΙΜΕΙ Συσκευής',
      key: 'deviceImei',
      dataIndex: 'deviceImei'
    },
    {
      title: 'Επίπεδο Μπαταρίας',
      key: 'batteryVoltage',
      dataIndex: 'batteryVoltage'
    },
    {
      title: 'Τελευταία ενημέρωση (timestamp)',
      key: 'batteryVoltageLastUpdated',
      dataIndex: 'batteryVoltageLastUpdated'
    },
  ];

  return (
    <MyTable
      columns={columns}
      endPoint={endPoint}
      exportFilename={exportFilename}
    />
  );
}
